<template>
  <div v-if="form_answers" class="table-responsive mt-3">
    <table class="table">
      <thead>
        <tr>
          <th scope="col">{{ $t('customerCard.tables.formUser') }}</th>
          <th scope="col">{{ $t('customerCard.tables.form') }}</th>
          <th scope="col">{{ $t('customerCard.tables.answerDate') }}</th>
          <th scope="col">{{ $t('customerCard.tables.servicesProduct') }}</th>
          <th scope="col">{{ $t('customerCard.tables.detail') }}</th>
          <th scope="col">{{ $t('customerCard.tables.action') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(answer, key) in form_answers" :key="key">
          <td>{{ contact.first_name + ' ' + contact.last_name }}</td>
          <td>{{ answer.form.name }}</td>
          <td>{{ moment(answer.created_at).format('Do MMMM YYYY HH:ss') }}</td>
          <td>{{ answer.service_id !== null ? answer.service.name : answer.product.name }}</td>
          <td>{{ moment(answer.event.start).format('Do MMMM YYYY HH:ss') }}</td>
          <td>
            <button
              type="button"
              class="btn btn-success btn-sm waves-effect waves-light"
              @click="
                answerModal[key] = !answerModal[key]
                $forceUpdate()
              "
            >
              <i class="bx bx-show font-size-14 align-middle mr-2"></i>
            </button>
            <b-modal v-model="answerModal[key]" hide-footer title="Cevap Detayı">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">{{ $t('customerCard.tables.question') }}</th>
                    <th scope="col">{{ $t('customerCard.tables.answer') }}</th>
                    <th scope="col">{{ $t('customerCard.tables.answerDate') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(answerDetail, detailKey) in answer.form_answer_fields"
                    :key="detailKey"
                  >
                    <td>{{ answerDetail.form_field_name }}</td>
                    <td>{{ answerDetail.content }}</td>
                    <td>{{ moment(answerDetail.created_at).format('Do MMMM YYYY HH:ss') }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="col-auto">
                <b-button @click="answerModal = {}">{{ $t('buttons.close') }}</b-button>
              </div>
            </b-modal>
          </td>
        </tr>
      </tbody>
    </table>
    <b-alert v-if="!form_answers.length" show class="text-center" variant="warning">{{
      $t('tableInfo.noData')
    }}</b-alert>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { GET_ANSWERS } from '@/router/queries'

export default {
  name: 'Forms',
  props: ['contact'],
  data() {
    return {
      moment,
      answerModal: {},
    }
  },
  computed: {
    ...mapState(['auth']),
  },
  created() {
    this.$_loading()
  },
  apollo: {
    form_answers: {
      fetchPolicy: 'no-cache',
      query: GET_ANSWERS,
      variables() {
        return {
          where: {
            contact_id: {
              _eq: this.$route.params.id,
            },
          },
        }
      },
    },
  },
}
</script>
